import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';

import type { TransformProps } from '../../../theme/system-utilities';
import { transform } from '../../../theme/system-utilities';
import ArrowIcon, { arrowIconStyles } from './ArrowIcon';
import type { ControlButtonProps } from './ControlButton';
import { ControlButton, controlButtonStyles } from './ControlButton';

const PrevControlButton = styled(ControlButton)<TransformProps>`
  ${transform};
`;

const prevControlStyles: ComponentProps<typeof PrevControlButton> = {
  ...controlButtonStyles,
  transform: 'rotate(180deg)',
};

const PrevControl = ({ disabled, handleClick }: ControlButtonProps) => (
  <PrevControlButton
    {...prevControlStyles}
    aria-disabled={disabled}
    onClick={handleClick}
    data-testid="carousel-prev-button"
    aria-hidden={true}
    disabled={disabled}
  >
    <ArrowIcon
      {...arrowIconStyles}
      stroke={disabled ? 'sys.neutral.icon.inactive' : 'sys.neutral.icon.default'}
    />
  </PrevControlButton>
);

export default PrevControl;
